/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ImportGroupStatus = {
    Draft: 'Draft',
    InProgress: 'InProgress',
    Completed: 'Completed',
    Failed: 'Failed'
} as const;
export type ImportGroupStatus = typeof ImportGroupStatus[keyof typeof ImportGroupStatus];


export function instanceOfImportGroupStatus(value: any): boolean {
    for (const key in ImportGroupStatus) {
        if (Object.prototype.hasOwnProperty.call(ImportGroupStatus, key)) {
            if (ImportGroupStatus[key as keyof typeof ImportGroupStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ImportGroupStatusFromJSON(json: any): ImportGroupStatus {
    return ImportGroupStatusFromJSONTyped(json, false);
}

export function ImportGroupStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportGroupStatus {
    return json as ImportGroupStatus;
}

export function ImportGroupStatusToJSON(value?: ImportGroupStatus | null): any {
    return value as any;
}

export function ImportGroupStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ImportGroupStatus {
    return value as ImportGroupStatus;
}

